import * as React from 'react';

import { AppContext } from '../AppContext';
import { AppContextData } from '../AppContextData';

export const useAppContext = (): AppContextData => React.useContext(AppContext);
